{
  "version": 1,
  "asset_id": "dd6fe8c3-123d-4f74-ab5e-68da3ce7fd09",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/dd6fe8c3-123d-4f74-ab5e-68da3ce7fd09/loc-the-woodlands-640.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/dd6fe8c3-123d-4f74-ab5e-68da3ce7fd09/loc-the-woodlands-640.avif",
  "original_filename": "loc-the-woodlands-640.avif",
  "size": 20203,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:26:34Z"
}
